import Config from "@/config/config.js";
import AsyncUtils from "@/utils/asyncUtils.js";
import Services, { handleError } from "./index.service";
import { getSession } from "@/hooks/useSession.js";

const { OshimedBackend, OshimedAPI } = Services;


/**
 * GET /notification/:userId — Récupère les notifications pour un utilisateur donné.
 *
 * @param {string} userId – L'identifiant de l'utilisateur (UUID ou DID).
 * @returns {Promise<object[]|null>} – Liste des notifications ou null si erreur.
 */
const getUserNotifications = async (userId) => {
    console.log("=== Service: getUserNotifications called === notification.service.js === key: 917744 ===");
    console.log("→ userId:", userId);
    console.log("=================================");
  
    if (!userId || typeof userId !== "string") {
      console.warn("Invalid userId passed to getUserNotifications");
      return null;
    }
  
    try {
      const response = await OshimedBackend.get(`/notification/${userId}`);
  
      if (!response?.data) {
        console.warn("Empty response from getUserNotifications");
        return null;
      }
  
      console.log("=== API response === notification.service.js === key: 917745 ===");
      console.dir(response.data, { depth: null, colors: true });
      console.log("=================================");
  
      return response.data;
    } catch (error) {
      console.error("Service error in getUserNotifications:", error);
      return handleError(error, 917746);
    }
  };





/**
 * POST /notification/mark-as-read — Marque certaines notifications comme lues.
 *
 * @param {string[]} notificationIds – Liste des IDs de notifications.
 * @param {string} userId – ID de l'utilisateur.
 * @returns {Promise<object|null>} – Résultat de l'opération ou erreur normalisée.
 */
const markNotificationsAsRead = async (notificationIds, userId) => {
  console.log("=== Service: markNotificationsAsRead called === notification.service.js === key: 918991 ===");
  console.log("→ notificationIds:", notificationIds);
  console.log("→ userId:", userId);
  console.log("=================================");

  if (!Array.isArray(notificationIds) || notificationIds.length === 0 || !userId) {
    console.warn("Invalid arguments passed to markNotificationsAsRead");
    return null;
  }

  try {
    const response = await OshimedBackend.post(`/notification/mark-as-read`, {
      notification_ids: notificationIds,
      user_id: userId,
    });

    if (!response?.data) {
      console.warn("Empty response from markNotificationsAsRead");
      return null;
    }

    console.log("=== API response === notification.service.js === key: 918992 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in markNotificationsAsRead:", error);
    return handleError(error, 918993);
  }
};

const NotificationService = {
   getUserNotifications, markNotificationsAsRead,
};

export default NotificationService;
export {  getUserNotifications, markNotificationsAsRead, };